<template>
  <div class="bill-details" ref="container">
    <div class="nav acea-row">
      <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
        申请管理中心
      </div>
      <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
        申请记录
      </div>
    </div>
    <div class="sign-record">
      <div class="list">
        <div class="item" v-for="(val, index) in list" :key="index">
          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">
                  <div class="name line1" style="color:#ff0000;" v-if="val.status == 2">{{val.grade_name}} {{ val.status_name }}</div>
                  <div class="name line1"  v-if="val.status == 0">{{val.grade_name}} {{ val.status_name }}</div>
                  <div class="name line1" style="color:#16ac57;" v-if="val.status == 1">{{val.grade_name}} {{ val.status_name }}</div>
                  <div v-if="val.admin_note" style="color:#ff0000;">不通过理由：{{val.admin_note}}</div>
                </div>
              </div>
              <div class="item"   style="width:100%;">
                <img :src="imgs" v-for="(imgs, i) in val.imgArr" @click="openIview(imgs, i)" :key="i" style="width:2rem;height:2rem;padding:0.2rem;" />
              </div>


              <div style="width:100%;">
                <div class="name line1"></div>

                <div  style="width:100%;" v-if="val.area">申请区域：{{ val.area }}</div>

                <div style="width:100%;">
                  <div style="float:left;width:50%;margin-top:0.2rem;">{{ val.add_time }}</div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .font-color-red-l {
    color:red !important;
  }
</style>
<script>
    import { getApplyList } from "../../api/user";
    import Loading from "@components/Loading";
    import {ImagePreview} from "vant";
    import Vue from "vue";
    Vue.use(ImagePreview);
    export default {
        name: "UserBill",
        components: {
            Loading
        },
        props: {},
        data: function() {
            return {
                types: 1,
                where: {
                    page: 1,
                    limit: 20
                },
                moneyType:[],
                list: [],
                loaded: false,
                loading: false
            };
        },
        watch: {
            "$route.params.types": function(newVal) {
                let that = this;
                if (newVal != undefined) {
                    that.types = newVal;
                    that.list = [];
                    that.where.page = 1;
                    that.loaded = false;
                    that.loading = false;
                    that.getIndex();
                }
            },
            types: function() {
                this.getIndex();
            }
        },
        mounted: function() {
            let that = this;
            that.getIndex();
            that.$scroll(that.$refs.container, () => {
            !that.loading && that.getIndex();
        });
        },
        methods: {
            code: function() {
                this.sendCode();
            },
            changeTypes: function(val) {
              if(val==0){
                this.$router.push({path:'/user/apply'})
              }else{
                this.$router.push({path:'/user/applyList'})
              }
            },
            getIndex: function() {
                let that = this;
                if (that.loaded == true || that.loading == true) return;
                that.loading = true;
                getApplyList(that.where).then(
                    res => {
                        that.loading = false;
                        that.loaded = res.data.list.length < that.where.limit;
                        that.where.page = that.where.page + 1;
                        that.list.push.apply(that.list, res.data.list);
                    },
                    error => {
                        that.$dialog.message(error.msg);
                    }
            );
            },
          openIview(item, index) {
            ImagePreview({
              images: item,
              startPosition: index,
              maxZoom: 3,
              minZoom: 1 / 3
            });
          }
        }
    };
</script>
